// extracted by mini-css-extract-plugin
export default {"eventModal":"styles_eventModal__etABT","eventModalWide":"styles_eventModalWide__Yvb0b"};